export default "__VITE_ASSET__CPGfQQJn__"